import { IAppState } from '../../common/state';
import { AUD_MAP_BANNER } from '../../constants/experiments';
import { dealTypeFromJsonQuery, FDealType, FOfferType, isUrban, offerTypeFromJsonQuery } from '../../utils/category';
import { isAbUseExperimentGroup } from '../../utils/experiments/isAbUseExperimentGroup';
import { abUseExperimentsSelector } from '../commonSelectors';
import { selectJsonQuery } from '../results';

export function selectMapBannerExperimentEnabled(state: IAppState): boolean {
  const experiments = abUseExperimentsSelector(state);
  const jsonQuery = selectJsonQuery(state);

  const offerType = offerTypeFromJsonQuery(jsonQuery);
  const dealType = dealTypeFromJsonQuery(jsonQuery);

  return (
    state.featureToggle.isMapBannerEnabled &&
    isUrban(offerType) &&
    offerType !== FOfferType.FlatNew &&
    Boolean(dealType & (FDealType.Sale | FDealType.RentLongterm)) &&
    isAbUseExperimentGroup(experiments, AUD_MAP_BANNER, 'B')
  );
}
